import { Navbar, NavItem } from "../components/Navbar"

export function InfoPageLayout({ children }: { children: React.ReactNode }) {
  const navProps: NavItem[] = [
      { name: "Home", path: "/" },
     /* { name: "About us", path: "/about" },*/
      /*{ name: "Pricing", path: "/pricing" },*/
      { name: "Login", path: "/login" },
      { name: "Contact us", path: "/contact-us" },
    ];
  return (
    <div className="info-page-layout">
          <Navbar navProps={navProps} showLocation={false} />
        <div>{children}</div>
    </div>
  );
}